/**
 * The clamp() function clamps a middle value within a range of values between a defined minimum bound and a maximum bound.
 * The function takes three parameters: a minimum value, a preferred value, and a maximum allowed value.
 */
export function clamp(min: number, preferred: number, max: number) {
  return Math.min(Math.max(preferred, min), max);
}
